// extracted by mini-css-extract-plugin
module.exports = {"actionButtons":"TimeCardTitle_actionButtons__3B1Cx"};